import axios from "axios"
import api from "../api"
import router from "@/router";

export const state = {
  user: {},
  submitDisabled: false
}

export const mutations = {
  SET_USER (state, user) {
    state.user = user
  },
  SET_DISABLED (state, disabled) {
    state.submitDisabled = disabled
  }
}

export const actions = {
  async login ({commit}, user) {
    try {
      commit("SET_DISABLED", true)
      const { data } = await axios.post(api.login, user)
      commit('SET_USER', data)
      commit("SET_DISABLED", false)
      await router.push("/dashboard")
    } catch (err) {
      console.log(err)
      commit("SET_DISABLED", false)
    }
  },
  async get_user ({ commit, dispatch }, next) {
    try {
      const { data: user } = await axios.get(api.login);
      if (user.name) {
        commit('SET_USER', user);
        next();
      }
    } catch (e) {
      next('/login');
    }
  },
  async logout ({ commit, dispatch }, next) {
    try {
      const { data: user } = await axios.delete(api.logout);
      await router.push('/login')
    } catch (e) {
      next('/login');
    }
  }
}